// extracted by mini-css-extract-plugin
export default {"workcellConfigDialog":"workcellConfigDialog-KM69e","title":"title-dJdB4"};